import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyPage from "./PolicyPage";
import "../css/terms.scss";

function Terms() {
  const sections = [
    {
      id: "store-status",
      title: "About these terms",
      paragraphs: [
        `These terms apply when you browse or place an order with ${siteConfig.company.legalName}. By submitting an order, you confirm that the information supplied is accurate and that you agree to these terms.`,
        "Product availability, delivery prices, promotions and payment status are confirmed during checkout.",
      ],
    },
    {
      id: "using-site",
      title: "Using the site",
      paragraphs: [
        "You may browse this site for lawful, personal purposes. You must not attempt to disrupt it, bypass security, introduce harmful code, scrape it at unreasonable volume, impersonate another person or use its content to mislead others.",
        "Access may be limited or withdrawn where necessary for maintenance, security or misuse. The site may change or become unavailable without notice.",
      ],
    },
    {
      id: "products",
      title: "Products and availability",
      paragraphs: [
        "Product names, descriptions, fibres, sizes, colours, inventory and imagery are sample content. Screens display colour differently and natural materials may vary in texture or shade. In a live store, the product page and order confirmation should identify the goods included in a purchase.",
        "An item appearing in the interface is not a promise of availability. A production system would verify stock before accepting an order and communicate any correction promptly.",
      ],
    },
    {
      id: "prices",
      title: "Prices, promotions and tax",
      paragraphs: [
        `Prices are displayed in ${siteConfig.currency}. Checkout shows the merchandise total, applicable delivery cost and final payment amount before an order is submitted.`,
        "Promotions may have separate eligibility, dates and exclusions. Unless expressly stated, discounts cannot be combined or applied retrospectively. Obvious pricing or description errors should be corrected before a production order is accepted.",
      ],
    },
    {
      id: "orders",
      title: "Orders and payment",
      paragraphs: [
        "In a production store, submitting checkout would be an offer to buy. An automated acknowledgement would confirm receipt, not necessarily acceptance; the sales contract would form at the point specified by the live terms, typically dispatch or an explicit acceptance notice.",
        "A live payment provider may authorise funds when checkout is submitted and capture them at the stated stage. Failed authentication, suspected fraud, unavailable stock or an undeliverable destination may cause an order to be declined or cancelled, with any captured sum returned.",
      ],
    },
    {
      id: "delivery-returns",
      title: "Delivery, cancellation and returns",
      paragraphs: [
        "Delivery windows are estimates unless a live checkout expressly guarantees a date. Title, risk, cancellation rights, return costs and refund timing must follow the final shipping and returns policies together with mandatory consumer law.",
        "Nothing in these sample terms is intended to exclude legal rights that cannot be limited by agreement, including remedies for goods that are faulty, misdescribed or not fit for their intended purpose.",
      ],
    },
    {
      id: "intellectual-property",
      title: "Content and intellectual property",
      paragraphs: [
        `The storefront layout, original copy, catalogue and ${siteConfig.brandName} brand materials are protected content. Unless a separate licence says otherwise, content may not be republished, sold or used to suggest endorsement. Third-party technologies remain subject to their respective licences.`,
      ],
    },
    {
      id: "links",
      title: "Links and third-party services",
      paragraphs: [
        "External links are provided for convenience. Their content, availability and privacy practices are controlled by their operators. A production store should identify third-party checkout, carrier or social services before data is shared with them.",
      ],
    },
    {
      id: "liability",
      title: "Responsibility",
      paragraphs: [
        "The site is provided with reasonable care, but uninterrupted availability or freedom from every technical error cannot be guaranteed.",
        "Nothing here excludes liability where exclusion is unlawful, including liability for fraud or for death or personal injury caused by negligence. Production limitations must be fair, transparent and tailored to applicable consumer law.",
      ],
    },
    {
      id: "law-contact",
      title: "Applicable law and contact",
      paragraphs: [
        `Final terms would identify the governing law and courts while preserving any mandatory protections available to a consumer where they live. Questions about this sample can be sent to ${siteConfig.contact.email} or by post to ${siteConfig.contact.address}.`,
      ],
    },
  ];

  return (
    <div className="terms">
      <PolicyPage
        eyebrow="Legal"
        title="Terms and conditions"
        intro={`Terms for browsing and ordering from ${siteConfig.brandName}.`}
        sections={sections}
        relatedLinks={[
          { label: "Privacy notice", to: "/privacy" },
          { label: "Shipping", to: "/shipping" },
          { label: "Returns", to: "/returns" },
          { label: "Contact", to: "/contact" },
        ]}
      />
    </div>
  );
}

export default Terms;
